import { render } from "./gf-switch.vue?vue&type=template&id=67970edb"
import script from "./gf-switch.vue?vue&type=script&lang=js"
export * from "./gf-switch.vue?vue&type=script&lang=js"

import "./gf-switch.vue?vue&type=style&index=0&id=67970edb&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__